<template>
    <div v-if="$mq === 'mobile'">
        <CCard class="tarjetaGesto">
            <CCardHeader>
                <h4>Templates Documentos</h4>
            </CCardHeader>
            <CCardBody>
                <CRow style="padding: 5px">
                    <CCol col="12">
                        <multiselect class="d-inline-block multSelectGesto"
                            v-show="tipoDocumentos.length>1"
                            v-model="tipoDocumentoSelected"
                            deselect-label="" 
                            label="nombreVisible"
                            placeholder="Documento"
                            select-label=""
                            selectedLabel=""
                            :options="tipoDocumentos" 
                            :searchable="true"
                            :loading="isLoadingTipoDocumentos"
                            :content="errorDctos==null?'Seleccionar documento':errorDctos"
                            v-tippy="{ 
                                placement: 'top',
                                arrow: true, 
                                arrowType: 'round', 
                                animation:'fade',
                                theme: 'google',
                                followCursor : true,
                            }"
                            @input="seleccionarTipoDocumento">
                        </multiselect>
                    </CCol>
                </CRow>
                <CRow style="padding: 5px">
                    <CCol col="12">
                        <multiselect
                            class="multSelectGesto mb-2"
                            v-model="empresaSelected"
                            selectedLabel=""
                            deselectLabel=""
                            selectLabel=""
                            placeholder="Empresas" 
                            label="nombreEmpresa" 
                            track-by="codEmpresa" 
                            :options="empresas" 
                            :multiple="false"
                            @input="seleccionarEmpresa">
                        </multiselect>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol col="12">
                        <CButton 
                            v-show="!mostrarSubirArchivos && this.empresaSelected != null && this.tipoDocumentoSelected != null"
                            size="sm"
                            class="btnPrincipalVapp mb-2 w-100" 
                            @click="subirDocumentoTemplate(null)">
                            
                            <CIcon :name="$utils.iconosGenerales('upload')"/>
                            Subir Nuevo Template
                        </CButton>
                        <CButton 
                            v-show="mostrarSubirArchivos && this.empresaSelected != null && this.tipoDocumentoSelected != null"
                            size="sm"
                            class="btnPrincipalVapp mb-2 w-100" 
                            @click="mostrarSubirArchivos = !mostrarSubirArchivos">
                            
                            <CIcon :name="$utils.iconosGenerales('upload')"/>
                            Ocultar subida de Template
                        </CButton>
                    </CCol>
                </CRow>
                <CRow v-if="mostrarSubirArchivos && this.empresaSelected != null && this.tipoDocumentoSelected != null">
                    <CCol>
                        <CRow v-if="documentoTemplateModal == null">
                            <CCol col="12">
                                <hr>
                                <multiselect class="multSelectGesto mb-2"
                                    openDirection="below"
                                    v-model="tipoSubDocumentoSelected"
                                    deselect-label="" 
                                    label="nombreVisibleSub"
                                    placeholder="Documento"
                                    select-label=""
                                    selectedLabel=""
                                    :options="tipoDocumentoSelected.tipoSubDocumentos" 
                                    :searchable="true"
                                    @input="seleccionarSubTipoDocumento"
                                    :multiple="false" :taggable="true"
                                    @tag="agregatTipoDoc"
                                    :content="`Seleccionar Tipo de ${tipoDocumentoSelected.nombreVisible}`"
                                    v-tippy="{ 
                                        placement: 'top',
                                        arrow: true, 
                                        arrowType: 'round', 
                                        animation:'fade',
                                        theme: 'google',
                                        followCursor : true,
                                    }">
                                </multiselect>
                            </CCol>
                        </CRow>

                        <CRow v-if="documentoTemplateModal != null">
                            <CCol>
                                <span style="font-size: 16px;  color:#0b7689">Reemplazar Template {{ documentoTemplateModal.nombreDocumento }}</span>
                            </CCol>
                        </CRow>
                        <CRow v-if="this.documentoTemplateModal == null ? tipoSubDocumentoSelected != null : true">
                            <CCol>
                                <CRow style="padding: 5px">
                                    <CCol>
                                        <file-upload
                                            class="btn btnPrincipalVapp w-100"
                                            :post-action="linkSubir"
                                            :headers="headers"
                                            :extensions="''"
                                            :accept="''"
                                            :multiple="false"
                                            :directory="false"
                                            :size="0"
                                            :thread="3"
                                            :drop="false"
                                            :drop-directory="false"
                                            :add-index="false"
                                            v-model="archivosSubir"
                                            @input-file="inputFile"
                                            ref="upload">
                                            <CIcon :content="$utils.iconosGenerales('agregar')" />
                                            Agregar Archivos
                                        </file-upload>
                                    </CCol>
                                </CRow>

                                <CRow style="padding: 5px">
                                    <CCol col="12">
                                        <CButton
                                            v-show="archivosSubir.length>0 && !isLoadingSubir"
                                            title="Cancelar subida archivo"
                                            class="btn-danger mr-2 w-100"
                                            size="sm"
                                            @click.prevent="archivosSubir = []">
                                            <CIcon :content="$utils.iconosGenerales('quitar')"/>
                                            Quitar Documentos
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <CRow style="padding: 5px">
                                    <CCol>
                                        <CButton
                                            v-show="archivosSubir.length>0"
                                            title="Cancelar subida archivo"
                                            class="btnPrincipalVapp w-100"
                                            size="sm"
                                            v-if="!$refs.upload || !$refs.upload.active"
                                            @click.prevent="subirTodoActivar(empresaSelected);">
                                            <CIcon :content="$utils.iconosGenerales('upload')"/>
                                            Subir todo
                                        </CButton>

                                        <CButton
                                            title="Cancelar subida archivo"
                                            class="btn-danger mr-2"
                                            size="sm"
                                            v-else
                                            @click.prevent="$refs.upload.active = false">
                                            <CIcon :content="$utils.iconosGenerales('cilXCircle')"/>
                                            Detener todo
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class="table-responsive">
                                    <a-table
                                        row-key="name"
                                        :columns="columnasSubidaArchivos" 
                                        :data-source="archivosSubir"
                                        :scroll="{ y: 400 }"
                                        class="tableInterior mt-3" 
                                        size="small">
                                        <span slot="nombreTemplate" slot-scope="archivo">
                                            <CInput
                                                class="pt-2"
                                                v-model="archivo.nombreTemplate"
                                                type="text"
                                                horizontal
                                                placeholder="Nombre Template"
                                                :disabled="archivo.active || archivo.success"
                                                @keyup="modificarNombreTemplate(archivo.nombreTemplate, archivo)"
                                            />
                                        </span>

                                        <span slot="nombreArchivo" slot-scope="archivo">

                                            <CRow>
                                                <CCol>{{archivo.name}}</CCol>
                                            </CRow>
                                            
                                        </span>
                                        <template slot="progreso" slot-scope="archivo">
                                            <CRow>
                                                <CCol>
                                                    <CProgress 
                                                    :value="parseFloat(archivo.progress)"
                                                    :precision="2" 
                                                    show-percentage 
                                                    :animated="true"
                                                    :color="(archivo.error)?'danger':'success'"
                                                    />
                                                </CCol>
                                            </CRow>
                                        </template>
                                        <template slot="tamanio" slot-scope="archivo">
                                            {{archivo.size | prettyBytes}}
                                        </template>

                                        <template slot="velocidad" slot-scope="archivo">
                                            {{ archivo.speed | prettyBytes }}/s
                                        </template>

                                        <template slot="estado" slot-scope="archivo">
                                            <span v-if="archivo.error" style="color:#7E1146">
                                                <span v-if="archivo.error === 'size'">
                                                    Archivo demasiado pequeño
                                                </span>
                                                
                                                <span v-else>
                                                    <CBadge color="danger"
                                                    :content="archivo.response.msjArchivo"
                                                        v-tippy="{ 
                                                            placement: 'top',
                                                            arrow: true, 
                                                            arrowType: 'round', 
                                                            animation:'fade',
                                                            theme: 'google',
                                                            followCursor : true,
                                                        }">
                                                        Problemas
                                                    </CBadge>
                                                </span>
                                            </span>
                                            <!--<CBadge v-if="archivo.error" color="danger">
                                                <span v-if="archivo.error === 'size'">
                                                    Archivo demasiado pequeño
                                                </span>
                                                <span v-else>{{ archivo.response }}</span>
                                            </CBadge>-->
                                            <span v-else-if="archivo.success" style="color: #2eb85c">
                                                <CBadge color="success"
                                                    :content="archivo.response.mensajeGeneral"
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }">
                                                    Correcto
                                                </CBadge>
                                                <CButton 
                                                    v-show="archivo.response.estado==2"
                                                    size="sm"
                                                    class="btnPrincipalVapp mb-2"
                                                    :content="'Configurar Variables'"
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }"
                                                    @click="configurarColumnas(archivo.response.campos, archivo.response.variablesDefTd)">
                                                    <CIcon :name="$utils.iconosGenerales('settings')" />
                                                </CButton>

                                            </span>
                                            <CBadge v-else-if="archivo.active" color="warning">
                                                Subiendo
                                            </CBadge>
                                            <CBadge v-else color="secondary" >
                                                En espera
                                            </CBadge>
                                        </template>

                                        <template slot="acciones" slot-scope="archivo">
                                            <CButtonGroup class="mx-1">
                                                <CButton
                                                    v-if="archivo.active" 
                                                    title="Cancelar subida archivo"
                                                    color="danger" 
                                                    size="sm"
                                                    @click.prevent="archivo.active? $refs.upload.update(archivo, { error: 'Cancelado' }): false">
                                                    <CIcon :name="$utils.iconosGenerales('cancelar')"/>
                                                </CButton>

                                                <CButton
                                                    v-else-if="archivo.error && archivo.error !== 'compressing' && $refs.upload.features.html5"
                                                    title="Recargar archivo"
                                                    color="info" 
                                                    size="sm"
                                                    @click.prevent="archivo.active || $refs.upload.update(archivo, {active: true,error: '',progress: '0.00'})">
                                                    <CIcon :content="$options.freeSet.cilLoopCircular"/>
                                                </CButton>

                                                <CButton
                                                    v-else
                                                    title="Subir archivo"
                                                    color="success" 
                                                    size="sm"
                                                    @click.prevent="archivo.success || archivo.error === 'compressing'? false: $refs.upload.update(archivo, { active: true })">
                                                    <CIcon :content="$utils.iconosGenerales('cilCloudUpload')"/>
                                                </CButton>

                                                <CButton
                                                    title="Quitar archivo"
                                                    color="danger" 
                                                    size="sm"
                                                    @click.prevent="$refs.upload.remove(archivo)">
                                                    <CIcon :name="$utils.iconosGenerales('basura') "/>
                                                </CButton>
                                                
                                            </CButtonGroup>
                                        </template>
                                        
                                        
                                    </a-table>
                                    
                                    <hr class="hr hr-blurry" />
                                </div>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <CargandoInfo :mostrarCarga="loadingDocumentosTemplate" :mensajeInfo="'Obteniendo Templates'" />
                <CRow>
                    <CCol col="12">
                        <CCard
                            v-for="doc in documentosTemplate" :key="doc"
                        >
                            <CCardBody>
                                <CCol>
                                    <CRow class="content-center">
                                        <span style="font-size: 15px"><strong>Nombre Documento Template:</strong></span>
                                    </CRow>
                                    <CRow class="content-center" style="padding-bottom: 10px;">
                                        <span style="font-size: 15px">{{doc.nombreDocumento}}</span>
                                    </CRow>
                                    <CRow class="content-center">
                                        <span style="font-size: 15px"><strong>Tipo Documento:</strong></span>
                                    </CRow>
                                    <CRow class="content-center" style="padding-bottom: 10px;">
                                        <span style="font-size: 15px">{{ doc.tipoDocumentoSubNombreVisible }}</span>
                                    </CRow>
                                    <CRow class="content-center" style="padding-bottom: 5px">
                                        <span style="font-size: 15px"><strong>Opciones Documentos:</strong></span>
                                    </CRow>
                                    <CRow class="content-center">
                                        <CCol>
                                            <CIcon v-show="loadingOpciones" :content="$options.freeSet.cilLoopCircular" class="imgr" />
                                            <CButtonGroup v-show="!loadingOpciones" style="gap: 15px">
                                                <CButton class="btnPrincipalVapp mr-1 btnEstilo"
                                                    v-if="doc.documento != null"
                                                    @click.prevent="verDocumento(doc.documento)"
                                                    size="sm"
                                                    content="Ver Documento"
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }"
                                                >
                                                    <CIcon :name="$utils.iconosGenerales('mostrar')" size="lg"/>
                                                </CButton>
                                                <CButton
                                                                v-if="doc.documento != null"
                                                                @click.prevent="eliminarDocumento(doc)"
                                                                class="mr-1 btnEstilo"
                                                                size="sm"
                                                                color="danger" 
                                                                content="Eliminar Documento"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                            >
                                                                <CIcon :name="$utils.iconosGenerales('cancelar')" size="lg"/>
                                                </CButton>
                                                <CButton class="btnPrincipalVapp mr-1 btnEstilo"
                                                    size="sm"
                                                    :content="(doc.documento != null)?'Reemplazar Documento':'Agregar Documento'"
                                                    @click.prevent="subirDocumentoTemplate(doc)"
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }"
                                                >
                                                    <CIcon :name="$utils.iconosGenerales('upload')" size="lg"/>
                                                </CButton>
                                                <CButton class="btnPrincipalVapp mr-1 btnEstilo"
                                                    size="sm"
                                                    @click="configurarVariablesTemplate(doc)"
                                                    :content="'Configurar Variables'"
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }"
                                                >
                                                    
                                                    <CIcon :name="$utils.iconosGenerales('settings')" size="lg"/>
                                                </CButton>
                                            </CButtonGroup>
                                        </CCol>
                                    </CRow>
                                </CCol>
                            </CCardBody>
                            
                        </CCard>
                    </CCol>
                </CRow>

            </CCardBody>
        </CCard>

        <Modal
            :enable-close="false"
            v-model="mostrarModalDocumento"
            :title="'Documento'"
            :modal-style="{ 'min-width': '300px', 'max-width': '1140px' }"
            @close="cerrarModalDocumento"
        >
            <CRow>
                <CCol>
                    <iframe
                    v-if="documentoModal != null"
                    :src="documentoModal.viewDocumento.replace('view', 'preview')"
                    width="100%"
                    height="400"
                    allow="autoplay"
                    ></iframe>
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="12" md="12" lg="12" align="right">

                    <CButton
                    md="3"
                    class="btnPrincipalVapp m-3"
                    style="margin: 20%"
                    @click="cerrarModalDocumento"
                    >Cerrar</CButton>
                </CCol>
            </CRow>

        </Modal>
        <Modal
            :enable-close="false"
            v-model="mostrarModalConfigColumnas"
            :title="'Configuración de variables'"
            :modal-style="{ 'max-height': '95vh', 
                            'max-width': '95vw' ,
                            'overflow' : 'auto'
                            }"
            @close="cerrarModalConfigColumnas"
        >
        
            <!--<div v-for="campo in camposConfigurar"
                v-bind:key="campo.variable">
            <CRow>
                <CCol col="5">
                    <label class="font-weight-bold" style="font-size: 12px;">Configurar variable "{{ campo.variable.nombreVariableDocumento }}"</label>
                </CCol>
                <CCol v-if="campo.varAsignada">
                    <CSwitch
                        width="150px"
                        class="mx-1 align-middle mb-2"
                        shape="pill"
                        variant="outline"
                        v-bind="{labelOn: 'Si',labelOff: 'No'}"
                        :checked="campo.editarCampo"
                        @update:checked="campo.editarCampo = !campo.editarCampo"
                        v-tippy="{ 
                            placement: 'top',
                            arrow: true, 
                            arrowType: 'round', 
                            animation:'fade',
                            theme: 'google',
                            followCursor : true,
                            content:'Modificar Campo'
                        }"
                    />
                </CCol>
                <CCol col="2">
                    <CSelect
                        v-if="(campo.varAsignada && campo.editarCampo) || (!campo.varAsignada)"
                        size="sm"
                        v-model="campo.opcionSeleccion"
                        :options="['Suma','Campo', 'Campo en Palabras']"
                        placeholder="Tipo"
                    />
                </CCol>
                <CCol col="4">
                    <multiselect
                    v-if="campo.opcionSeleccion != null && ((campo.varAsignada && campo.editarCampo) || (!campo.varAsignada))"
                        class="mb-2 multSelectGesto"
                        open-direction="bottom"                                     
                        select-label=""
                        selectedLabel=""
                        deselect-label=""
                        selectGroupLabel=""
                        deselectGroupLabel=""
                        :multiple="false" 
                        v-model="campo.varSeleccionada" 
                        :options="opcionesNose" 
                        group-values="opcionesCampos" 
                        group-label="nombreProviene" 
                        :group-select="false" 
                        placeholder="Seleccione un Campo" 
                        label="textoMostrar"
                        :show-labels="true"
                       >
                        
                        <span slot="noResult">Oops! no se encuentran datos con esa palabra</span>
                        
                    </multiselect>
                    
                </CCol>
            </CRow>
            </div>-->
            <CCol col="12">
                <CRow>
                    <CCol col="6"><!-- align="right"-->
                        <CButton
                            class="btnPrincipalVapp m-3 w-100"
                            style="margin: 20%"
                            @click="aceptarModificaciones"
                            :disabled="configurandoVariables"
                        >
                            <CIcon v-show="configurandoVariables" :content="$options.freeSet.cilLoopCircular" class="imgr" />
                            Asignar opciones seleccionadas
                        </CButton>
                    </CCol>
                    <CCol col="6">
                        <CButton
                            class="btnPrincipalVapp m-3 float-right"
                            style="margin: 20%"
                            @click="cerrarModalConfigColumnas"
                            >Cerrar configuración
                        </CButton>
                    </CCol>
                </CRow>
                <CRow class="center-content">
                    <CCol col="12" class="align-items-center font-weight-bold" style="font-size: 14px;">
                        Nombre Variable a configurar
                    </CCol>
                </CRow>
                <hr>
                <CRow>
                    <CCol col="12">
                        <CCard
                            :key="campo.variable.nombreVariableDocumento" v-for="(campo, i) in camposConfigurar"
                        >
                            <CCardHeader>
                                <CRow class="content-center">
                                    <label class="font-weight-bold" style="font-size: 14px; padding-bottom: 3px;">"{{ campo.variable.nombreVariableDocumento }}"</label>
                                </CRow>
                                <CRow class="content-center">
                                    <CCol v-if="campo.varAsignada">
                                        <CSwitch
                                            width="150px"
                                            class="mx-1 align-middle mb-2"
                                            shape="pill"
                                            variant="outline"
                                            v-bind="{labelOn: 'Si',labelOff: 'No'}"
                                            :checked="campo.editarCampo"
                                            @update:checked="activarSwitch(campo)"
                                        /> 
                                    </CCol>
                                </CRow>
                                <CRow v-if="campo.editarCampo" class="content-center" style="padding-top: 5px;">
                                    <CLink class="card-header-action btn-minimize" @click="plegarCollapse(campo)">
                                        <CIcon :name="`cil-chevron-${campo.desplegado ? 'bottom' : 'top'}`" />
                                    </CLink>
                                </CRow>
                            </CCardHeader>

                            <CCollapse v-show="campo.desplegado">
                                <CCardBody v-show="campo.editarCampo">
                                    <center class="font-weight-bold" style="font-size: 14px; padding-bottom:5px;">Opciones Variables</center>
                                    <CRow class="content-center" style="padding-bottom: 5px;">
                                        <CCol col="6" class="font-weight-bold" style="font-size: 14px;">
                                            <center>Tipo Campo:</center>
                                        </CCol>
                                        <CCol col="6" class="font-weight-bold" style="font-size: 14px;">
                                            <center>Campo Variable:</center>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <!--<CSelect
                                                v-if="(campo.varAsignada && campo.editarCampo) || (!campo.varAsignada)"
                                                size="sm"
                                                v-model="campo.opcionSeleccion"
                                                :options="['Suma','Campo', 'Campo en Palabras']"
                                                placeholder="Tipo"
                                            />-->
                                            <multiselect class="m-0 d-inline-block mb-2 multSelectGestoTC" 
                                                v-if="(campo.varAsignada && campo.editarCampo) || (!campo.varAsignada)"
                                                v-model="campo.opcionSeleccion"
                                                open-direction="bottom" 
                                                deselect-label="" 
                                                placeholder="Tipo" 
                                                select-label=""
                                                selectedLabel=""
                                                :options="['Suma','Campo', 'Campo en Palabras', 'Suma en Palabras']"
                                                :searchable="false">
                                            </multiselect>
                                        </CCol>
                                        <CCol col="6">
                                            <multiselect
                                                v-if="campo.opcionSeleccion != null && ((campo.varAsignada && campo.editarCampo) || (!campo.varAsignada))"
                                                class="mb-2 multSelectGestoTC"
                                                open-direction="bottom"                                     
                                                select-label=""
                                                selectedLabel=""
                                                deselect-label=""
                                                selectGroupLabel=""
                                                deselectGroupLabel=""
                                                :multiple="false" 
                                                v-model="campo.varSeleccionada" 
                                                :options="opcionesNose" 
                                                group-values="opcionesCampos" 
                                                group-label="nombreProviene" 
                                                :group-select="false" 
                                                placeholder="Seleccione un Campo" 
                                                label="textoMostrar"
                                                :show-labels="true"
                                            >
                                                
                                                <span slot="noResult">Oops! no se encuentran datos con esa palabra</span>
                                                
                                            </multiselect>
                                            <!--<multiselect class="m-0 d-inline-block mb-2 multSelectGesto" 
                                                v-model="campo.varSeleccionada"
                                                open-direction="bottom" 
                                                deselect-label="" 
                                                label="nombreVisible" 
                                                placeholder="Campo Variable" 
                                                select-label=""
                                                selectedLabel=""
                                                :options="variablesOpciones2"
                                                :searchable="true"
                                                @input="seleccionarCampo(campo)">
                                            </multiselect>-->
                                        </CCol>
                                    </CRow>
                                </CCardBody>
                            </CCollapse>
                        </CCard>
                    </CCol>
                </CRow>
            </CCol>
            <!--<div class="vm-content">
                <vs-table striped style="min-height: 400px; max-height: 400px; overflow-x: auto;">
                    <template #thead>
                        <vs-tr>
                            <vs-th
                                v-for="col in columnasConfigVariables"
                                :style="{ width: col.width }"
                                v-bind:key="col.key"
                            >
                                {{ col.title }}
                            </vs-th>
                        </vs-tr>
                    </template>
                    <template #tbody>
                        <vs-tr :key="campo.variable.nombreVariableDocumento" v-for="(campo, i) in camposConfigurar"
                            :data="campo"
                            not-click-selected
                        >
                            <vs-td style="width: 40%;">
                                <label class="font-weight-bold" style="font-size: 12px;">Configurar variable "{{ campo.variable.nombreVariableDocumento }}"</label>
                            </vs-td>
                            <vs-td style="width: 60%;">
                                <CRow>
                                    <CCol col="3" v-if="campo.varAsignada">
                                        <CSwitch
                                            width="150px"
                                            class="mx-1 align-middle mb-2"
                                            shape="pill"
                                            variant="outline"
                                            v-bind="{labelOn: 'Si',labelOff: 'No'}"
                                            :checked="campo.editarCampo"
                                            v-tippy="{ 
                                                placement: 'top',
                                                arrow: true, 
                                                arrowType: 'round', 
                                                animation:'fade',
                                                theme: 'google',
                                                followCursor : true,
                                                content:'Modificar Campo'
                                            }"
                                            @update:checked="campo.editarCampo = !campo.editarCampo"
                                        />
                                    </CCol>
                                    <CCol col="3">
                                        <multiselect class="m-0 d-inline-block mb-2 multSelectGesto" 
                                            v-if="(campo.varAsignada && campo.editarCampo) || (!campo.varAsignada)"
                                            v-model="campo.opcionSeleccion"
                                            open-direction="bottom" 
                                            deselect-label="" 
                                            placeholder="Tipo" 
                                            select-label=""
                                            selectedLabel=""
                                            :options="['Suma','Campo', 'Campo en Palabras', 'Suma en Palabras']"
                                            :searchable="false">
                                        </multiselect>
                                    </CCol>
                                    <CCol col="6">
                                        <multiselect
                                            v-if="campo.opcionSeleccion != null && ((campo.varAsignada && campo.editarCampo) || (!campo.varAsignada))"
                                            class="mb-2 multSelectGesto"
                                            open-direction="bottom"                                     
                                            select-label=""
                                            selectedLabel=""
                                            deselect-label=""
                                            selectGroupLabel=""
                                            deselectGroupLabel=""
                                            :multiple="false" 
                                            v-model="campo.varSeleccionada" 
                                            :options="opcionesNose" 
                                            group-values="opcionesCampos" 
                                            group-label="nombreProviene" 
                                            :group-select="false" 
                                            placeholder="Seleccione un Campo" 
                                            label="textoMostrar"
                                            :show-labels="true"
                                        >
                                            
                                            <span slot="noResult">Oops! no se encuentran datos con esa palabra</span>
                                            
                                        </multiselect>
                                    </CCol>
                                </CRow>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>-->

        </Modal>


    </div>
    <div v-else>
        <CRow>
            <CCol md="12" lg="12">
                <CCard class="tarjetaGesto">
                    <CCardHeader>
                        <h4>Templates Documentos</h4>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol md="2"><!--select tipo Dcto-->
                                <multiselect class="d-inline-block multSelectGesto"
                                    v-show="tipoDocumentos.length>1"
                                    v-model="tipoDocumentoSelected"
                                    deselect-label="" 
                                    label="nombreVisible"
                                    placeholder="Documento"
                                    select-label=""
                                    selectedLabel=""
                                    :options="tipoDocumentos" 
                                    :searchable="true"
                                    :loading="isLoadingTipoDocumentos"
                                    :content="errorDctos==null?'Seleccionar documento':errorDctos"
                                    v-tippy="{ 
                                        placement: 'top',
                                        arrow: true, 
                                        arrowType: 'round', 
                                        animation:'fade',
                                        theme: 'google',
                                        followCursor : true,
                                    }"
                                    @input="seleccionarTipoDocumento">
                                </multiselect>
                            </CCol>
                            <CCol md="3">
                                <multiselect
                                    class="multSelectGesto mb-2"
                                    v-model="empresaSelected"
                                    selectedLabel=""
                                    deselectLabel=""
                                    selectLabel=""
                                    placeholder="Empresas" 
                                    label="nombreEmpresa" 
                                    track-by="codEmpresa" 
                                    :options="empresas" 
                                    :multiple="false"
                                    @input="seleccionarEmpresa">
                                </multiselect>
                            </CCol>
                            <!--<CCol md="2" v-show="tipoDocumentoSelected != null" >
                                mostrar por periodo 
                                <CSwitch
                                    width="150px"
                                    class="mx-1 align-middle mb-2"
                                    shape="pill"
                                    variant="outline"
                                    :checked="mostrarPeriodo"
                                    @update:checked="mostrarPeriodo = !mostrarPeriodo"
                                />
                            </CCol>
                            <CCol md="2" v-show="(tipoDocumentoSelected != null) ? mostrarPeriodo : false">
                                <multiselect class="m-0 d-inline-block mb-2 multSelectGesto" 
                                    v-model="periodoSelected"
                                    deselect-label="" 
                                    label="nombrePeriodo" 
                                    placeholder="Periodo" 
                                    select-label=""
                                    selectedLabel=""
                                    :options="periodos" 
                                    :searchable="true"
                                    :loading="isLoadingPeriodos"
                                    :disabled="(tipoDocumentoSelected == null)?true:false"
                                    @input="seleccionarAnioPeriodo">
                                </multiselect>
                            </CCol>
                            <CCol md="2" v-show="(tipoDocumentoSelected != null) ? mostrarPeriodo : false">
                                <multiselect class="m-0 d-inline-block mb-2 multSelectGesto" 
                                    v-model="mesSelected"
                                    deselect-label="" 
                                    label="nombreMes" 
                                    placeholder="Mes" 
                                    select-label=""
                                    selectedLabel=""
                                    :options="(periodoSelected == null)?[]:periodoSelected.meses"
                                    :searchable="true"
                                    :loading="isLoadingMes"
                                    :disabled="(periodoSelected == null)?true:false"
                                    @input="seleccionarMeses">
                                </multiselect>
                            </CCol>-->   
                        </CRow>
                        <CRow>
                            <CCol>
                                <CButton 
                                    v-show="!mostrarSubirArchivos && this.empresaSelected != null && this.tipoDocumentoSelected != null"
                                    size="sm"
                                    class="btnPrincipalVapp mb-2" 
                                    @click="subirDocumentoTemplate(null)">
                                    
                                    <CIcon :name="$utils.iconosGenerales('upload')"/>
                                    Subir Nuevo Template
                                </CButton>
                                <CButton 
                                    v-show="mostrarSubirArchivos && this.empresaSelected != null && this.tipoDocumentoSelected != null"
                                    size="sm"
                                    class="btnPrincipalVapp mb-2" 
                                    @click="mostrarSubirArchivos = !mostrarSubirArchivos">
                                    
                                    <CIcon :name="$utils.iconosGenerales('upload')"/>
                                    Ocultar subida de Template
                                </CButton>
                            </CCol>
                        </CRow>
                        <CRow v-if="mostrarSubirArchivos && this.empresaSelected != null && this.tipoDocumentoSelected != null">
                            <CCol>
                                <CRow v-if="documentoTemplateModal == null">
                                    <CCol col="3">
                                        <multiselect class="multSelectGesto mb-2"
                                            openDirection="below"
                                            v-model="tipoSubDocumentoSelected"
                                            deselect-label="" 
                                            label="nombreVisibleSub"
                                            placeholder="Documento"
                                            select-label=""
                                            selectedLabel=""
                                            :options="tipoDocumentoSelected.tipoSubDocumentos" 
                                            :searchable="true"
                                            @input="seleccionarSubTipoDocumento"
                                            :multiple="false" :taggable="true"
                                            @tag="agregatTipoDoc"
                                            :content="`Seleccionar Tipo de ${tipoDocumentoSelected.nombreVisible}`"
                                            v-tippy="{ 
                                                placement: 'top',
                                                arrow: true, 
                                                arrowType: 'round', 
                                                animation:'fade',
                                                theme: 'google',
                                                followCursor : true,
                                            }">
                                        </multiselect>

                                        <!--<multiselect class="d-inline-block multSelectGesto"
                                            v-model="tipoSubDocumentoSelected"
                                            deselect-label="" 
                                            label="nombreVisibleSub"
                                            placeholder="Documento"
                                            select-label=""
                                            selectedLabel=""
                                            :options="tipoDocumentoSelected.tipoSubDocumentos" 
                                            :searchable="true"
                                            :content="errorDctos==null?'Seleccionar Tipo Documento':errorDctos"
                                            v-tippy="{ 
                                                placement: 'top',
                                                arrow: true, 
                                                arrowType: 'round', 
                                                animation:'fade',
                                                theme: 'google',
                                                followCursor : true,
                                            }"
                                            @input="seleccionarTipoDocumento">
                                        </multiselect>-->
                                    </CCol>
                                </CRow>

                                <CRow v-if="documentoTemplateModal != null">
                                    <CCol>
                                        <span style="font-size: 16px;  color:#0b7689">Reemplazar Template {{ documentoTemplateModal.nombreDocumento }}</span>
                                    </CCol>
                                </CRow>
                                <CRow v-if="this.documentoTemplateModal == null ? tipoSubDocumentoSelected != null : true">
                                    <CCol>
                                        <!--<button
                                            type="button"
                                            class="btn btn-danger float-right btn-is-option mb-2"
                                            @click.prevent="empresa.isOption = !empresa.isOption">
                                            <i class="fa fa-cog" aria-hidden="true"></i> Opciones
                                        </button>-->
                                            
                                            <file-upload
                                                class="btn btnPrincipalVapp mr-2"
                                                :post-action="linkSubir"
                                                :headers="headers"
                                                :extensions="''"
                                                :accept="''"
                                                :multiple="false"
                                                :directory="false"
                                                :size="0"
                                                :thread="3"
                                                :drop="false"
                                                :drop-directory="false"
                                                :add-index="false"
                                                v-model="archivosSubir"
                                                @input-file="inputFile"
                                                ref="upload">
                                                <CIcon :content="$utils.iconosGenerales('agregar')" />
                                                Agregar Archivos
                                            </file-upload>
                                            
                                            <CButton
                                                v-show="archivosSubir.length>0 && !isLoadingSubir"
                                                title="Cancelar subida archivo"
                                                class="btn-danger mr-2"
                                                size="sm"
                                                @click.prevent="archivosSubir = []">
                                                <CIcon :content="$utils.iconosGenerales('quitar')"/>
                                                Quitar Documentos
                                            </CButton>

                                            <CButton
                                                v-show="archivosSubir.length>0"
                                                title="Cancelar subida archivo"
                                                class="btnPrincipalVapp mr-2"
                                                size="sm"
                                                v-if="!$refs.upload || !$refs.upload.active"
                                                @click.prevent="subirTodoActivar(empresaSelected);">
                                                <CIcon :content="$utils.iconosGenerales('upload')"/>
                                                Subir todo
                                            </CButton>
                                            
                                            <CButton
                                                title="Cancelar subida archivo"
                                                class="btn-danger mr-2"
                                                size="sm"
                                                v-else
                                                @click.prevent="$refs.upload.active = false">
                                                <CIcon :content="$utils.iconosGenerales('cilXCircle')"/>
                                                Detener todo
                                            </CButton>

                                        <div class="table-responsive">
                                            <a-table
                                                row-key="name"
                                                :columns="columnasSubidaArchivos" 
                                                :data-source="archivosSubir"
                                                :scroll="{ y: 400 }"
                                                class="tableInterior mt-3" 
                                                size="small">
                                                <span slot="nombreTemplate" slot-scope="archivo">
                                                    <CInput
                                                        class="pt-2"
                                                        v-model="archivo.nombreTemplate"
                                                        type="text"
                                                        horizontal
                                                        placeholder="Nombre Template"
                                                        :disabled="archivo.active || archivo.success"
                                                        @keyup="modificarNombreTemplate(archivo.nombreTemplate, archivo)"
                                                    />
                                                </span>

                                                <span slot="nombreArchivo" slot-scope="archivo">

                                                    <CRow>
                                                        <CCol>{{archivo.name}}</CCol>
                                                    </CRow>
                                                    
                                                </span>
                                                <template slot="progreso" slot-scope="archivo">
                                                    <CRow>
                                                        <CCol>
                                                            <CProgress 
                                                            :value="parseFloat(archivo.progress)"
                                                            :precision="2" 
                                                            show-percentage 
                                                            :animated="true"
                                                            :color="(archivo.error)?'danger':'success'"
                                                            />
                                                        </CCol>
                                                    </CRow>
                                                </template>
                                                <template slot="tamanio" slot-scope="archivo">
                                                    {{archivo.size | prettyBytes}}
                                                </template>

                                                <template slot="velocidad" slot-scope="archivo">
                                                    {{ archivo.speed | prettyBytes }}/s
                                                </template>

                                                <template slot="estado" slot-scope="archivo">
                                                    <span v-if="archivo.error" style="color:#7E1146">
                                                        <span v-if="archivo.error === 'size'">
                                                            Archivo demasiado pequeño
                                                        </span>
                                                        
                                                        <span v-else>
                                                            <CBadge color="danger"
                                                            :content="archivo.response.msjArchivo"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }">
                                                                Problemas
                                                            </CBadge>
                                                        </span>
                                                    </span>
                                                    <!--<CBadge v-if="archivo.error" color="danger">
                                                        <span v-if="archivo.error === 'size'">
                                                            Archivo demasiado pequeño
                                                        </span>
                                                        <span v-else>{{ archivo.response }}</span>
                                                    </CBadge>-->
                                                    <span v-else-if="archivo.success" style="color: #2eb85c">
                                                        <CBadge color="success"
                                                            :content="archivo.response.mensajeGeneral"
                                                            v-tippy="{ 
                                                                placement: 'top',
                                                                arrow: true, 
                                                                arrowType: 'round', 
                                                                animation:'fade',
                                                                theme: 'google',
                                                                followCursor : true,
                                                            }">
                                                            Correcto
                                                        </CBadge>
                                                        <CButton 
                                                            v-show="archivo.response.estado==2"
                                                            size="sm"
                                                            class="btnPrincipalVapp mb-2"
                                                            :content="'Configurar Variables'"
                                                            v-tippy="{ 
                                                                placement: 'top',
                                                                arrow: true, 
                                                                arrowType: 'round', 
                                                                animation:'fade',
                                                                theme: 'google',
                                                                followCursor : true,
                                                            }"
                                                            @click="configurarColumnas(archivo.response.campos, archivo.response.variablesDefTd)">
                                                            <CIcon :name="$utils.iconosGenerales('settings')" />
                                                        </CButton>

                                                    </span>
                                                    <CBadge v-else-if="archivo.active" color="warning">
                                                        Subiendo
                                                    </CBadge>
                                                    <CBadge v-else color="secondary" >
                                                        En espera
                                                    </CBadge>
                                                </template>

                                                <template slot="acciones" slot-scope="archivo">
                                                    <CButtonGroup class="mx-1">
                                                        <CButton
                                                            v-if="archivo.active" 
                                                            title="Cancelar subida archivo"
                                                            color="danger" 
                                                            size="sm"
                                                            @click.prevent="archivo.active? $refs.upload.update(archivo, { error: 'Cancelado' }): false">
                                                            <CIcon :name="$utils.iconosGenerales('cancelar')"/>
                                                        </CButton>

                                                        <CButton
                                                            v-else-if="archivo.error && archivo.error !== 'compressing' && $refs.upload.features.html5"
                                                            title="Recargar archivo"
                                                            color="info" 
                                                            size="sm"
                                                            @click.prevent="archivo.active || $refs.upload.update(archivo, {active: true,error: '',progress: '0.00'})">
                                                            <CIcon :content="$options.freeSet.cilLoopCircular"/>
                                                        </CButton>

                                                        <CButton
                                                            v-else
                                                            title="Subir archivo"
                                                            color="success" 
                                                            size="sm"
                                                            @click.prevent="archivo.success || archivo.error === 'compressing'? false: $refs.upload.update(archivo, { active: true })">
                                                            <CIcon :content="$utils.iconosGenerales('cilCloudUpload')"/>
                                                        </CButton>

                                                        <CButton
                                                            title="Quitar archivo"
                                                            color="danger" 
                                                            size="sm"
                                                            @click.prevent="$refs.upload.remove(archivo)">
                                                            <CIcon :name="$utils.iconosGenerales('basura') "/>
                                                        </CButton>
                                                        
                                                    </CButtonGroup>
                                                </template>
                                                
                                                
                                            </a-table>
                                            
                                            <hr class="hr hr-blurry" />
                                        </div>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CargandoInfo :mostrarCarga="loadingDocumentosTemplate" :mensajeInfo="'Obteniendo Templates'" />
                        <CRow v-show="!loadingDocumentosTemplate">
                            <CCol col="12">
                                <vs-table striped  style="min-height: 400px;">
                                    <template #thead>
                                        <vs-tr>
                                            <vs-th
                                                v-for="col in columnasDocumentosTemplate"
                                                :style="{ width: col.width }"
                                                v-bind:key="col.key"
                                            >
                                                {{ col.title }}
                                            </vs-th>
                                        </vs-tr>
                                    </template>
                                    <template #tbody>
                                        <vs-tr :key="i" v-for="(documento, i) in documentosTemplate"
                                            :data="documento"
                                            not-click-selected
                                            open-expand-only-td
                                        >
                                            <vs-td>
                                                <CRow>
                                                    <CCol>{{documento.nombreDocumento}}</CCol>
                                                </CRow>
                                            </vs-td>
                                            <vs-td>
                                                {{documento.tipoDocumentoSubNombreVisible}}
                                            </vs-td>
                                            <vs-td>
                                                <CRow>
                                                    <CCol>
                                                        <CIcon v-show="loadingOpciones" :content="$options.freeSet.cilLoopCircular" class="imgr" />
                                                        <CButtonGroup class="mx-1" v-show="!loadingOpciones">
                                                            <CButton class="btnPrincipalVapp mr-1"
                                                                v-if="documento.documento != null"
                                                                @click.prevent="verDocumento(documento.documento)"
                                                                size="sm"
                                                                content="Ver Documento"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                            >
                                                                <CIcon :name="$utils.iconosGenerales('mostrar')" />
                                                            </CButton>
                                                            <CButton
                                                                v-if="documento.documento != null"
                                                                @click.prevent="eliminarDocumento(documento)"
                                                                class="mr-1"
                                                                size="sm"
                                                                color="danger" 
                                                                content="Eliminar Documento"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                            >
                                                                <CIcon :name="$utils.iconosGenerales('cancelar')"/>
                                                            </CButton>
                                                            <CButton class="btnPrincipalVapp mr-1"
                                                                size="sm"
                                                                :content="(documento.documento != null)?'Reemplazar Documento':'Agregar Documento'"
                                                                @click.prevent="subirDocumentoTemplate(documento)"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                            >
                                                                <CIcon :name="$utils.iconosGenerales('upload')"/>
                                                            </CButton>
                                                            <CButton class="btnPrincipalVapp mr-1"
                                                                size="sm"
                                                                @click="configurarVariablesTemplate(documento)"
                                                                :content="'Configurar Variables'"
                                                                v-tippy="{ 
                                                                    placement: 'top',
                                                                    arrow: true, 
                                                                    arrowType: 'round', 
                                                                    animation:'fade',
                                                                    theme: 'google',
                                                                    followCursor : true,
                                                                }"
                                                            >
                                                                
                                                                <CIcon :name="$utils.iconosGenerales('settings')" />
                                                            </CButton>
                                                        </CButtonGroup>
                                                        <!--<CDropdown 
                                                            color="drpdwn-menu"
                                                            class="mt-1 d-inline-block mb-1"
                                                            size="sm"
                                                            :content="'Opciones '"
                                                            v-tippy="{ 
                                                                placement: 'top',
                                                                arrow: true, 
                                                                arrowType: 'round', 
                                                                animation:'fade',
                                                                theme: 'google',
                                                                followCursor : true,
                                                            }">
                                                            <template #toggler-content>
                                                                <CIcon :content="$options.freeSet.cilApplications" />
                                                            </template>
                                                            <div role="group">
                                                                <CDropdownItem >
                                                                    Prueba1
                                                                </CDropdownItem>
                                                                <CDropdownItem >
                                                                    Prueba2
                                                                </CDropdownItem>
                                                                
                                                                <CDropdownDivider /> 

                                                                <CDropdownItem>
                                                                    prueba123
                                                                </CDropdownItem>
                                                            </div>
                                                        </CDropdown>-->
                                                    </CCol>
                                                    <!--<CCol v-show="documento.archivosSubir != null">
                                                    
                                                        <button v-show="documento.archivosSubir != null"
                                                            style="font-size: 11px;"
                                                            type="button"
                                                            class="btn btnPrincipalVapp"
                                                            >
                                                            <CIcon :content="$options.freeSet.cilCloudUpload"/>
                                                            Subir
                                                        </button>
                                                    </CCol>
                                                    <CCol v-show="documento.archivosSubir != null">
                                                        <button v-show="documento.archivosSubir != null"
                                                            style="font-size: 11px;"
                                                            type="button"
                                                            class="btn btnPrincipalVapp"
                                                            @click="documento.archivosSubir = null"
                                                            >
                                                            <CIcon :content="$options.freeSet.cilCloudUpload"/>
                                                            quitar
                                                        </button>
                                                    </CCol>-->
                                                    <!--<CCol md="5">
                                                        <button
                                                            style="font-size: 11px;"
                                                            type="button"
                                                            class="btn btnPrincipalVapp"
                                                            v-if="!$refs.upload || !$refs.upload.active"
                                                            @click.prevent="subirTodoActivar(empresa);">
                                                            <CIcon :content="$options.freeSet.cilCloudUpload"/>
                                                            Subir todo
                                                        </button>
                                                    </CCol>
                                                    <CCol md="1">
                                                        <CProgress v-if="documento.documentosNuevo.documentos.length >0"
                                                            :value="parseFloat(documento.documentosNuevo.documentos[0].progress)"
                                                            :precision="2" 
                                                            show-percentage 
                                                            :animated="true"
                                                            :color="(documento.documentosNuevo.documentos[0].error)?'danger':'success'"
                                                            />
                                                    </CCol>-->

                                                </CRow>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                    <template #notFound>
                                        No hay templates
                                    </template>

                                </vs-table>
                            </CCol>
                        </CRow>

                        
                    </CCardBody>
                    <CCardFooter>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
        <!--<GestionDocumentos v-if="empresaSelected != null && tipoDocumentoSelected != null" 
        :padre="this" 
        :mostrarGestionDocumentos="false" 
        :empresa="empresaSelected" 
        :tipoDocumentoSelected="tipoDocumentoSelected"
        :documentoTemplateSelected="documentoTemplateModal" />-->
        
        <Modal
            :enable-close="false"
            v-model="mostrarModalDocumento"
            :title="'Documento'"
            :modal-style="{ 'min-width': '300px', 'max-width': '1140px' }"
            @close="cerrarModalDocumento"
        >
            <CRow>
                <CCol>
                    <iframe
                    v-if="documentoModal != null"
                    :src="documentoModal.viewDocumento.replace('view', 'preview')"
                    width="100%"
                    height="400"
                    allow="autoplay"
                    ></iframe>
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="12" md="12" lg="12" align="right">

                    <CButton
                    md="3"
                    class="btnPrincipalVapp m-3"
                    style="margin: 20%"
                    @click="cerrarModalDocumento"
                    >Cerrar</CButton>
                </CCol>
            </CRow>

        </Modal>
        <Modal
            :enable-close="false"
            v-model="mostrarModalConfigColumnas"
            :title="'Configuración de variables'"
            :modal-style="{ 'min-widtht': '300px', 
                            'max-width': '800px' ,
                            'overflow' : 'auto'
                            }"
            @close="cerrarModalConfigColumnas"
        >
        
            <!--<div v-for="campo in camposConfigurar"
                v-bind:key="campo.variable">
            <CRow>
                <CCol col="5">
                    <label class="font-weight-bold" style="font-size: 12px;">Configurar variable "{{ campo.variable.nombreVariableDocumento }}"</label>
                </CCol>
                <CCol v-if="campo.varAsignada">
                    <CSwitch
                        width="150px"
                        class="mx-1 align-middle mb-2"
                        shape="pill"
                        variant="outline"
                        v-bind="{labelOn: 'Si',labelOff: 'No'}"
                        :checked="campo.editarCampo"
                        @update:checked="campo.editarCampo = !campo.editarCampo"
                        v-tippy="{ 
                            placement: 'top',
                            arrow: true, 
                            arrowType: 'round', 
                            animation:'fade',
                            theme: 'google',
                            followCursor : true,
                            content:'Modificar Campo'
                        }"
                    />
                </CCol>
                <CCol col="2">
                    <CSelect
                        v-if="(campo.varAsignada && campo.editarCampo) || (!campo.varAsignada)"
                        size="sm"
                        v-model="campo.opcionSeleccion"
                        :options="['Suma','Campo', 'Campo en Palabras']"
                        placeholder="Tipo"
                    />
                </CCol>
                <CCol col="4">
                    <multiselect
                    v-if="campo.opcionSeleccion != null && ((campo.varAsignada && campo.editarCampo) || (!campo.varAsignada))"
                        class="mb-2 multSelectGesto"
                        open-direction="bottom"                                     
                        select-label=""
                        selectedLabel=""
                        deselect-label=""
                        selectGroupLabel=""
                        deselectGroupLabel=""
                        :multiple="false" 
                        v-model="campo.varSeleccionada" 
                        :options="opcionesNose" 
                        group-values="opcionesCampos" 
                        group-label="nombreProviene" 
                        :group-select="false" 
                        placeholder="Seleccione un Campo" 
                        label="textoMostrar"
                        :show-labels="true"
                       >
                        
                        <span slot="noResult">Oops! no se encuentran datos con esa palabra</span>
                        
                    </multiselect>
                    
                </CCol>
            </CRow>
            </div>-->
            <CRow>
                <CCol sm="12" md="12" lg="12"><!-- align="right"-->
                    <CButton
                        md="3"
                        class="btnPrincipalVapp m-3"
                        style="margin: 20%"
                        @click="aceptarModificaciones"
                        :disabled="configurandoVariables"
                    >
                        <CIcon v-show="configurandoVariables" :content="$options.freeSet.cilLoopCircular" class="imgr" />
                        Asignar opciones seleccionadas
                    </CButton>

                    <CButton 
                        md="3"
                        class="btnPrincipalVapp m-3 float-right"
                        style="margin: 20%"
                        @click="cerrarModalConfigColumnas"
                        >Cerrar configuración
                    </CButton>
                </CCol>
            </CRow>
            <CRow>
                <CCol col="5" class="d-flex align-items-center font-weight-bold" style="font-size: 14px;">
                    Nombre Variable a configurar
                </CCol>
                <CCol col="7" class="font-weight-bold" style="font-size: 14px;">
                    <center>Opciones Variables</center>
                    <CRow>
                        <CCol col="6"><center>Tipo Campo</center></CCol>
                        <CCol col="6"><center>Campo Variable</center></CCol>
                    </CRow>
                </CCol>
            </CRow>
            <hr>
            <div style="max-height: 60vh; overflow: auto;">
                <CRow :key="campo.variable.nombreVariableDocumento" v-for="(campo, i) in camposConfigurar" class="center-content">
                    <CCol col="1" v-if="campo.varAsignada">
                        <CSwitch
                            width="150px"
                            class="mx-1 align-middle mb-2"
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: 'Si',labelOff: 'No'}"
                            :checked="campo.editarCampo"
                            v-tippy="{ 
                                placement: 'top',
                                arrow: true, 
                                arrowType: 'round', 
                                animation:'fade',
                                theme: 'google',
                                followCursor : true,
                                content:'Modificar Campo'
                            }"
                            @update:checked="campo.editarCampo = !campo.editarCampo"
                        />
                    </CCol>
                    <CCol col="4" style="text-align: left;">
                        <label class="font-weight-bold" style="font-size: 12px; padding-top: 3px;">"{{ campo.variable.nombreVariableDocumento }}"</label>
                    </CCol>
                    <CCol col="7">
                        <CRow>
                            <CCol col="6">
                                <!--<CSelect
                                    v-if="(campo.varAsignada && campo.editarCampo) || (!campo.varAsignada)"
                                    size="sm"
                                    v-model="campo.opcionSeleccion"
                                    :options="['Suma','Campo', 'Campo en Palabras']"
                                    placeholder="Tipo"
                                />-->
                                <multiselect class="m-0 d-inline-block mb-2 multSelectGestoTC" 
                                    v-if="(campo.varAsignada && campo.editarCampo) || (!campo.varAsignada)"
                                    v-model="campo.opcionSeleccion"
                                    open-direction="bottom" 
                                    deselect-label="" 
                                    placeholder="Tipo" 
                                    select-label=""
                                    selectedLabel=""
                                    :options="['Suma','Campo', 'Campo en Palabras', 'Suma en Palabras']"
                                    :searchable="false">
                                </multiselect>
                            </CCol>
                            <CCol col="6">
                                <multiselect
                                    v-if="campo.opcionSeleccion != null && ((campo.varAsignada && campo.editarCampo) || (!campo.varAsignada))"
                                    class="mb-2 multSelectGestoTC"
                                    open-direction="bottom"                                     
                                    select-label=""
                                    selectedLabel=""
                                    deselect-label=""
                                    selectGroupLabel=""
                                    deselectGroupLabel=""
                                    :multiple="false" 
                                    v-model="campo.varSeleccionada" 
                                    :options="opcionesNose" 
                                    group-values="opcionesCampos" 
                                    group-label="nombreProviene" 
                                    :group-select="false" 
                                    placeholder="Seleccione un Campo" 
                                    label="textoMostrar"
                                    :show-labels="true"
                                >
                                    
                                    <span slot="noResult">Oops! no se encuentran datos con esa palabra</span>
                                    
                                </multiselect>
                                <!--<multiselect class="m-0 d-inline-block mb-2 multSelectGesto" 
                                    v-model="campo.varSeleccionada"
                                    open-direction="bottom" 
                                    deselect-label="" 
                                    label="nombreVisible" 
                                    placeholder="Campo Variable" 
                                    select-label=""
                                    selectedLabel=""
                                    :options="variablesOpciones2"
                                    :searchable="true"
                                    @input="seleccionarCampo(campo)">
                                </multiselect>-->
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </div>
            <!--<div class="vm-content">
                <vs-table striped style="min-height: 400px; max-height: 400px; overflow-x: auto;">
                    <template #thead>
                        <vs-tr>
                            <vs-th
                                v-for="col in columnasConfigVariables"
                                :style="{ width: col.width }"
                                v-bind:key="col.key"
                            >
                                {{ col.title }}
                            </vs-th>
                        </vs-tr>
                    </template>
                    <template #tbody>
                        <vs-tr :key="campo.variable.nombreVariableDocumento" v-for="(campo, i) in camposConfigurar"
                            :data="campo"
                            not-click-selected
                        >
                            <vs-td style="width: 40%;">
                                <label class="font-weight-bold" style="font-size: 12px;">Configurar variable "{{ campo.variable.nombreVariableDocumento }}"</label>
                            </vs-td>
                            <vs-td style="width: 60%;">
                                <CRow>
                                    <CCol col="3" v-if="campo.varAsignada">
                                        <CSwitch
                                            width="150px"
                                            class="mx-1 align-middle mb-2"
                                            shape="pill"
                                            variant="outline"
                                            v-bind="{labelOn: 'Si',labelOff: 'No'}"
                                            :checked="campo.editarCampo"
                                            v-tippy="{ 
                                                placement: 'top',
                                                arrow: true, 
                                                arrowType: 'round', 
                                                animation:'fade',
                                                theme: 'google',
                                                followCursor : true,
                                                content:'Modificar Campo'
                                            }"
                                            @update:checked="campo.editarCampo = !campo.editarCampo"
                                        />
                                    </CCol>
                                    <CCol col="3">
                                        <multiselect class="m-0 d-inline-block mb-2 multSelectGesto" 
                                            v-if="(campo.varAsignada && campo.editarCampo) || (!campo.varAsignada)"
                                            v-model="campo.opcionSeleccion"
                                            open-direction="bottom" 
                                            deselect-label="" 
                                            placeholder="Tipo" 
                                            select-label=""
                                            selectedLabel=""
                                            :options="['Suma','Campo', 'Campo en Palabras', 'Suma en Palabras']"
                                            :searchable="false">
                                        </multiselect>
                                    </CCol>
                                    <CCol col="6">
                                        <multiselect
                                            v-if="campo.opcionSeleccion != null && ((campo.varAsignada && campo.editarCampo) || (!campo.varAsignada))"
                                            class="mb-2 multSelectGesto"
                                            open-direction="bottom"                                     
                                            select-label=""
                                            selectedLabel=""
                                            deselect-label=""
                                            selectGroupLabel=""
                                            deselectGroupLabel=""
                                            :multiple="false" 
                                            v-model="campo.varSeleccionada" 
                                            :options="opcionesNose" 
                                            group-values="opcionesCampos" 
                                            group-label="nombreProviene" 
                                            :group-select="false" 
                                            placeholder="Seleccione un Campo" 
                                            label="textoMostrar"
                                            :show-labels="true"
                                        >
                                            
                                            <span slot="noResult">Oops! no se encuentran datos con esa palabra</span>
                                            
                                        </multiselect>
                                    </CCol>
                                </CRow>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>-->

        </Modal>

    
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


<script>
    
    import cons from '@/const'
    import axios from "axios"

    import Multiselect from 'vue-multiselect'
    
    import VueModal from "@kouts/vue-modal";
    import "@kouts/vue-modal/dist/vue-modal.css";

    
    import { freeSet } from '@coreui/icons'

    window.locale = 'es'
    
    
    import FileUpload from "vue-upload-component";
    import apiUrls from '@/views/utils/apiUrls'
    import CargandoInfo from '@/views/utils/CargandoInfo'
    import GestionDocumentos from "./componentes/GestionDocumentos";

    export default {
        name: 'ContratosFiniquitos',
        freeSet,
        components: {
            Multiselect,
            'Modal': VueModal,
            FileUpload,
            CargandoInfo,
            GestionDocumentos,
        },
        data () {
            return {
                urlBase: cons.port+"://" + cons.ipServer,
                tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                tipoUserAdmin: JSON.parse(this.$cookie.get('userLogginToken')).tipoUsuario,
                idCliente: JSON.parse(this.$cookie.get('userLogginToken')).idCliente,
                
                columnasDocumentosTemplate: [
                    { title: 'Nombre Documento Template', scopedSlots: { customRender: 'nombreDocumento' }, width: '30%', align: 'left' ,ellipsis: false},
                    { title: 'Tipo Documento', scopedSlots:{ customRender: 'tipoDocumento' }, width: '30%', align: 'left', ellipsis: false},
                    { title: 'Opciones Documento', scopedSlots: { customRender: 'documento' }, width: '30%', align: 'left', ellipsis: false},
                ],
                documentosTemplate: [],

                headers: {
                    Authorization: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                },
                mostrarSubirArchivos: false,
                
                isLoadingMes: false,
                isLoadingPeriodos: false,
                isLoadingTipoDocumentos: false,
                tipoDocumentoSelected: null,
                errorDctos: null,
                tipoDocumentos: [],

                mostrarPeriodo: false,
                isLoadingEmpresasInfo: false,
                empresaSelected: null,
                empresasInfo: [],
                periodos: [],
                periodoSelected: null,
                mesSelected: null,

                rqstEmp: null,
                empresas: [],
                isLoadingEmpresas: false,
                paginacionEmpresas: { pageSize: 30, hideOnSinglePage: true },

                documentoTemplateModal: null,

                tipoSubDocumentoSelected: null,

                linkSubir: '',
                archivosSubir: [],
                subidaDocsID: null,
                isLoadingSubir: false,
                headers: {
                    Authorization: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                },

                columnasSubidaArchivos: [
                    { title: 'Nombre Template', scopedSlots: { customRender: 'nombreTemplate' }, width: '25%', align: 'left' ,ellipsis: false},
                    { title: 'Nombre Archivo', scopedSlots: { customRender: 'nombreArchivo' }, width: '15%', align: 'left' ,ellipsis: false},
                    { title: 'Progreso', scopedSlots:{ customRender: 'progreso' }, width: '10%', align: 'center', ellipsis: false},
                    { title: 'Tamaño', scopedSlots: { customRender: 'tamanio' }, width: '10%', align: 'left', ellipsis: false},
                    { title: 'Velocidad', scopedSlots: { customRender: 'velocidad' }, width: '10%', align: 'center', ellipsis: false},
                    { title: 'Estado', scopedSlots: { customRender: 'estado' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'Acciones', scopedSlots: { customRender: 'acciones' }, width: '20%', align: 'center', ellipsis: false},
                ],

                mostrarModalConfigColumnas: false,

                templateModificar: null,
                camposConfigurar: {},
                variablesOpciones: [],
                opcionSeleccion: null,

                mostrarModalDocumento: false,
                documentoModal: null,

                loadingOpciones: false,
                loadingDocumentosTemplate: false,

                configurandoVariables: false,

                columnasConfigVariables: [
                    { title: 'Nombre Variable', scopedSlots: { customRender: 'nombreVariable' }, width: '40%', align: 'left' ,ellipsis: false},
                    { title: 'Opciones Variables', scopedSlots: { customRender: 'opcionesVariables' }, width: '60%', align: 'left', ellipsis: false},
                ],

                opcionesNose: [
                    {
                        "nombreProviene": "Campos Empresa",
                        "opcionesCampos": [
                            {"textoMostrar": "Rut Empresa", "campo": "rutEmpresa", "proviene": "empresa"},
                            {"textoMostrar": "Nombre Empresa", "campo": "nombreEmpresa", "proviene": "empresa"},
                            {"textoMostrar": "Giro Empresa", "campo": "giro", "proviene": "empresa"},
                            {"textoMostrar": "Dirección", "campo": "calle", "proviene": "empresa"},
                            {"textoMostrar": "Numero Dirección", "campo": "numeroCalle", "proviene": "empresa"},
                            {"textoMostrar": "N° Oficina", "campo": "numOficina", "proviene": "empresa"},
                            {"textoMostrar": "Representante Legal", "campo": "repLegal", "proviene": "empresa"},
                            {"textoMostrar": "Rut Representante Legal", "campo": "rutRepLegal", "proviene": "empresa"},
                            {"textoMostrar": "Ciudad Empresa", "campo": "ciudadEmpresa", "proviene": "empresa"},
                            {"textoMostrar": "Comuna Empresa", "campo": "comuna", "proviene": "empresa"}
                        ],
                    },
                    {
                        "nombreProviene": "Campos Trabajadores",
                        "opcionesCampos": [
                            {"textoMostrar": "Nombre Trabajador", "campo": "nombreTrabajador","proviene": "trabajador"},
                            {"textoMostrar": "Rut Trabajador", "campo": "rutTrabajador","proviene": "trabajador"},
                            {"textoMostrar": "Nacionalidad", "campo": "nacionalidad","proviene": "trabajador"},
                            {"textoMostrar": "Fecha Nacimiento", "campo": "fnacimiento","proviene": "trabajador"},
                            {"textoMostrar": "Estado Civil", "campo": "estadoCivil","proviene": "trabajador"},
                            {"textoMostrar": "Dirección", "campo": "direccion","proviene": "trabajador"},
                            {"textoMostrar": "Procedencia", "campo": "ctoProcedencia","proviene": "trabajador"},
                            {"textoMostrar": "Comuna", "campo":  "comunaTrabajador","proviene": "trabajador"},
                            {"textoMostrar": "Villa/Poblacion", "campo": "villaPoblacion","proviene": "trabajador"},
                            {"textoMostrar": "Genero", "campo": "genero","proviene": "trabajador"},
                            {"textoMostrar": "Cargo", "campo": "cargoTrabajador","proviene": "trabajador"},
                        ]
                    },
                    {
                        "nombreProviene": "Campos Contrato",
                        "opcionesCampos": [
                            {"textoMostrar": "Fecha Emision", "campo": "ctoEmision", "proviene": "contrato"},
                            {"textoMostrar": "Fecha Inicio", "campo": "ctoInicio", "proviene": "contrato"},
                            {"textoMostrar": "Vencimiento", "campo": "ctoVencimiento", "proviene": "contrato"},
                            {"textoMostrar": "Jornada", "campo": "jornadaCtro", "proviene": "contrato"},
                            {"textoMostrar": "Tipo Jornada", "campo": "ctoTipoJornada", "proviene": "contrato"},
                            {"textoMostrar": "Tipo", "campo": "ctoTipo", "proviene": "contrato"},
                            {"textoMostrar": "Tipo Contrato", "campo": "ctoTipoContrato", "proviene": "contrato"},
                            {"textoMostrar": "Horas Jornada", "campo": "cctoHorasSemana", "proviene": "contrato"},
                            {"textoMostrar": "Días Jornada", "campo": "diasJornada", "proviene": "contrato"},
                            {"textoMostrar": "Dias Trabajo", "campo": "numDiasTrabajo", "proviene": "contrato"},
                        ],
                    },
                    {
                        
                        "nombreProviene": "Campos Sucursal",
                        "opcionesCampos":[
                            {"textoMostrar": "Sección", "campo": "seccion", "proviene": "sucursal"},
                            {"textoMostrar": "Sucursal", "campo": "sucursal", "proviene": "sucursal"}
                        ]
                    },
                    {
                        "nombreProviene": "Campos Haberes/Descuentos",
                        "opcionesCampos": [
                            {"textoMostrar": "Descripcion Haber/Descuento", "campo": "textoHd", "proviene": "habDes"},
                            {"textoMostrar": "Valor Haber/Descuento", "campo": "valorHd", "proviene": "habDes"},
                            {"textoMostrar": "Tipo Moneda Haber/Descuento", "campo": "tipoMoneda", "proviene": "habDes"},
                        ],
                    }
                ],

                camposEmpresa: [
                    {"textoMostrar": "Rut Empresa", "campo": "rutEmpresa"},
                    {"textoMostrar": "Nombre Empresa", "campo": "nombreEmpresa"},
                    {"textoMostrar": "Giro Empresa", "campo": "giro"},
                    {"textoMostrar": "Dirección", "campo": "calle"},
                    {"textoMostrar": "Numero Dirección", "campo": "numeroCalle"},
                    {"textoMostrar": "N° Oficina", "campo": "numOficina"},
                    {"textoMostrar": "Representante Legal", "campo": "repLegal"},
                    {"textoMostrar": "Rut Representante Legal", "campo": "rutRepLegal"},
                    {"textoMostrar": "Ciudad Empresa", "campo": "ciudadEmpresa"},
                    {"textoMostrar": "Comuna Empresa", "campo": "comuna"}
                ],
                camposHabDes: [
                    {"textoMostrar": "descripcion Haber/Descuento", "campo": "textoHd"},
                    {"textoMostrar": "Valor Haber/Descuento", "campo": "valorHd"},
                ],
                camposTrabajador: [
                    {"textoMostrar": "Nombre Trabajador", "campo": "nombreTrabajador"},
                    {"textoMostrar": "Rut Trabajador", "campo": "rutTrabajador"},
                    {"textoMostrar": "Nacionalidad", "campo": "nacionalidad"},
                    {"textoMostrar": "Fecha Nacimiento", "campo": "fnacimiento"},
                    {"textoMostrar": "Estado Civil", "campo": "estadoCivil"},
                    {"textoMostrar": "Dirección", "campo": "direccion"},
                    {"textoMostrar": "Procedencia", "campo": "ctoProcedencia"},
                    {"textoMostrar": "Comuna", "campo":  "comunaTrabajador"},
                    {"textoMostrar": "Villa/Poblacion", "campo": "villaPoblacion"},
                    {"textoMostrar": "Genero", "campo": "genero"},
                    {"textoMostrar": "Cargo", "campo": "cargoTrabajador"},
                ],
                camposCtro: [
                    {"textoMostrar": "Fecha Emision", "campo": "ctoEmision"},
                    {"textoMostrar": "Fecha Inicio", "campo": "ctoInicio"},
                    {"textoMostrar": "Vencimiento", "campo": "ctoVencimiento"},
                    {"textoMostrar": "Jornada", "campo": "jornadaCtro"},
                    {"textoMostrar": "Tipo Jornada", "campo": "ctoTipoJornada"},
                    {"textoMostrar": "Tipo", "campo": "ctoTipo"},
                    {"textoMostrar": "Tipo Contrato", "campo": "ctoTipoContrato"},
                    {"textoMostrar": "Horas Jornada", "campo": "cctoHorasSemana"},
                    {"textoMostrar": "Días Jornada", "campo": "diasJornada"},
                    {"textoMostrar": "Dias Trabajo", "campo": "numDiasTrabajo"},
                ],
                seccionSucursal:[
                    {"textoMostrar": "Sección", "campo": "seccion"},
                    {"textoMostrar": "Sucursal", "campo": "sucursal"}
                ],


                variables: [
                    { "varSeleccionada": null, "variable": { "idTemplateDocumento": 66, "nombreVariableDocumento": "Monto_en_Palabras_Total_del_Finiquito" }},
                    { "varSeleccionada": null, "variable": { "idTemplateDocumento": 66, "nombreVariableDocumento": "Valor_Total_del_Finiquito" } }
                ],
                
                variablesOpciones2: [ { "idVariable": 12, "nombreVisible": "Fecha Vencimiento en Palabras", "nombreVariable": "Fecha_Vencimiento_en_Palabras", "campoProviene": "contrato", "campoVariable": "fechaVencimientoCto" }, { "idVariable": 13, "nombreVisible": "Fecha Emision en palabras", "nombreVariable": "Fecha_de_Contrato_en_Palabras", "campoProviene": "contrato", "campoVariable": "fechaEmisionCto" }, { "idVariable": 14, "nombreVisible": "Procedencia Trabajador", "nombreVariable": "Procedencia_del_Trabajador", "campoProviene": "trabajador", "campoVariable": "ctoProcedencia" }, { "idVariable": 15, "nombreVisible": "Jornada de trabajo", "nombreVariable": "Jornada_de_Trabajo", "campoProviene": "contrato", "campoVariable": "jornadaCto" }, { "idVariable": 16, "nombreVisible": "Cargo Trabajador", "nombreVariable": "Cargo_del_Trabajador", "campoProviene": "cargo", "campoVariable": "cargoTrabajador" }, { "idVariable": 17, "nombreVisible": "Nombre Trabajador", "nombreVariable": "Nombre_del_Trabajador", "campoProviene": "trabajador", "campoVariable": "nombreTrabajador" }, { "idVariable": 18, "nombreVisible": "Numero de direccion Empleador", "nombreVariable": "Numero_de_Direccion_del_Empleador", "campoProviene": "empresa", "campoVariable": "numeroCalle" }, { "idVariable": 19, "nombreVisible": "Duracion Contrato", "nombreVariable": "Duracion_del_Contrato", "campoProviene": "contrato", "campoVariable": "tipoContratoCto" }, { "idVariable": 20, "nombreVisible": "Nombre Empleador", "nombreVariable": "Nombre_del_Empleador", "campoProviene": "empresa", "campoVariable": "nombreEmpresa" }, { "idVariable": 21, "nombreVisible": "Domicilio Trabajador", "nombreVariable": "Domicilio_del_Trabajador", "campoProviene": "trabajador", "campoVariable": "direccion" }, { "idVariable": 22, "nombreVisible": "Oficina Empleador", "nombreVariable": "Oficina_del_Empleador", "campoProviene": "empresa", "campoVariable": "numOficina" }, { "idVariable": 23, "nombreVisible": "Emisión Finiquito", "nombreVariable": "Fecha_Emision_en_Palabras", "campoProviene": "finiquito", "campoVariable": "fechaEmision" }, { "idVariable": 24, "nombreVisible": "Ciudad Empleador", "nombreVariable": "Ciudad_del_Empleador", "campoProviene": "empresa", "campoVariable": "ciudadEmpresa" }, { "idVariable": 25, "nombreVisible": "Comuna Empleador", "nombreVariable": "Comuna_del_Empleador", "campoProviene": "empresa", "campoVariable": "comuna" }, { "idVariable": 26, "nombreVisible": "Descripción Causal Finiquito", "nombreVariable": "Causal_de_Despido", "campoProviene": "finiquito", "campoVariable": "descripcionFiniquito" }, { "idVariable": 27, "nombreVisible": "Nacionalidad Trabajador", "nombreVariable": "Nacionalidad_del_Trabajador", "campoProviene": "trabajador", "campoVariable": "nacionalidad" }, { "idVariable": 28, "nombreVisible": "Direccion Empleador", "nombreVariable": "Dirección_del_Empleador", "campoProviene": "empresa", "campoVariable": "direccionEmpresa" }, { "idVariable": 30, "nombreVisible": "Rut Trabajador", "nombreVariable": "Rut_del_Trabajador", "campoProviene": "trabajador", "campoVariable": "rutTrabajador" }, { "idVariable": 31, "nombreVisible": "Fecha Inicio Contrato en Palabras", "nombreVariable": "Fecha_Inicio_en_Palabras", "campoProviene": "contrato", "campoVariable": "fechaInicioCto" }, { "idVariable": 32, "nombreVisible": "Tipo Jornada Trabajador", "nombreVariable": "Tipo_de_Jornada", "campoProviene": "contrato", "campoVariable": "tipoJornadaCto" }, { "idVariable": 33, "nombreVisible": "Seccion Trabajador", "nombreVariable": "Seccion_del_Trabajador", "campoProviene": "seccion", "campoVariable": "seccion" }, { "idVariable": 34, "nombreVisible": "Codigo Causal Finiquito", "nombreVariable": "Codigo_del_Articulo_del_Trabajo", "campoProviene": "finiquito", "campoVariable": "causalFiniquito" }, { "idVariable": 35, "nombreVisible": "Comuna Trabajador", "nombreVariable": "Comuna_del_Trabajador", "campoProviene": "trabajador", "campoVariable": "comunaTrabajador" }, { "idVariable": 36, "nombreVisible": "Fecha Termino Finiquito", "nombreVariable": "Fecha_de_Finiquito_en_Palabras", "campoProviene": "finiquito", "campoVariable": "fechaTermino" }, { "idVariable": 37, "nombreVisible": "Rut Representante Legal", "nombreVariable": "Rut_Representante_Legal", "campoProviene": "empresa", "campoVariable": "rutRepLegal" }, { "idVariable": 38, "nombreVisible": "Rut Empleador", "nombreVariable": "Rut_del_Empleador", "campoProviene": "empresa", "campoVariable": "rutEmpresa" }, { "idVariable": 39, "nombreVisible": "Estado Civil Trabajador", "nombreVariable": "Estado_Civil_del_Trabajador", "campoProviene": "trabajador", "campoVariable": "estadoCivil" }, { "idVariable": 40, "nombreVisible": "Nombre Representante legal", "nombreVariable": "Nombre_Representante_Legal", "campoProviene": "empresa", "campoVariable": "repLegal" }, { "idVariable": 41, "nombreVisible": "Calle Emplreador", "nombreVariable": "Calle_del_Empleador", "campoProviene": "empresa", "campoVariable": "calle" }, { "idVariable": 42, "nombreVisible": "Fecha Emision en palabras", "nombreVariable": "Fecha_Emision_en_Palabras", "campoProviene": "contrato", "campoVariable": "fechaEmisionCto" }, { "idVariable": 29, "nombreVisible": "Fecha nacimiento Trabajador en palabras", "nombreVariable": "Fecha_de_Nacimiento_del_Trabajador_en_Pa", "campoProviene": "trabajador", "campoVariable": "fnacimiento" } 
                ],

                colapsado: [],

            }
        },
        created: function(){},
        
        watch: { 
        },
        beforeMount() {
            let cookieUsername = this.$cookie.get('userLogginToken')
            
            if(cookieUsername === null || cookieUsername === ""){
                this.$router.push("/pages/login");
            }

            this.mostrarPeriodo = /^true$/i.test(this.$route.query.mostrarPeriodo)
            this.obtenerTiposDocumentos()
            this.obtenerPeriodos()
            if(this.mostrarPeriodo){
                if(this.periodoSelected != null && this.mesSelected != null)
                    this.obtenerEmpresas()
            } else{
                this.obtenerEmpresas()
            }

        },
        mounted(){
        },
        beforeDestroy () {
            
            
        },
        methods: {
            activarSwitch: function(campo){
                campo.editarCampo = !campo.editarCampo
                this.plegarCollapse(campo)
            },
            plegarCollapse: function(campo) {
                if (campo.editarCampo) {
                    //this.$set(this.colapsado, i, !this.colapsado[i]);
                    if (campo.hasOwnProperty('desplegado')){
                        campo.desplegado = !campo.desplegado
                    } else {
                        this.$set(campo, 'desplegado', true)
                    }
                }
            },
            verDocumento: function(documento){
                this.documentoModal = documento
                this.mostrarModalDocumento = true

            },
            cerrarModalDocumento: function(){
                this.mostrarModalDocumento = false
            },
            eliminarDocumento: function(documento){
                this.loadingOpciones = true
                let url =  this.urlBase + "/eliminar_template/"
                axios({
                        method: "POST", 
                        "url": url,
                        "data": {
                            "idTemplate": documento.idTemplateDocumento,
                            "idEmpresaTemplate": this.empresaSelected.idEmpresa
                        },
                        "headers": {
                            'Authorization': `${this.tokenLogin}`
                        }
                    }).then(result => {
                        this.mostrarNotificaciones(1, result.data.mensajeGeneral)
                        this.documentosTemplate.splice(this.documentosTemplate.indexOf(documento), 1)
                        //this.getDocumentosTemplate()

                        w
                    }, error => {
                        this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                    })
                    .finally(() => {
                        this.loadingOpciones = false
                    });
            },
            aceptarModificaciones: function(){
                let modificados = []
                let idTemplate = null
                this.camposConfigurar.forEach(campo =>{
                    if(campo.varSeleccionada != null)
                        idTemplate = campo.variable.idTemplateDocumento
                        modificados.push({
                            "opcionSeleccion": campo.opcionSeleccion,
                            "variableDefecto": campo.varSeleccionada,
                            "variableTemplate": campo.variable,
                            "varAsignada": campo.varAsignada,
                            "editarCampo": campo.editarCampo
                        })
                })
                this.configurandoVariables = true
                let url =  this.urlBase + "/configurar_variables_template"
                if(idTemplate == null){
                    idTemplate = this.templateModificar.idDocumento
                }
                axios({
                        method: "POST", 
                        "url": url,
                        "data": {
                            "modificados": modificados,
                            "idTemplate": idTemplate,
                            "idEmpresaTemplate": this.empresaSelected.idEmpresa
                        },
                        "headers": {
                            'Authorization': `${this.tokenLogin}`
                        }
                    }).then(result => {
                        this.configurandoVariables = false
                        this.mostrarNotificaciones(1, result.data.mensajeGeneral)
                        
                    }, error => {
                        
                        this.configurandoVariables = false
                    })
                    .finally(() => {
                        
                        this.configurandoVariables = false

                    });

            },
            seleccionarCampo: function(value){
                for (let i = 0; i < this.variablesOpciones.length; i++) {
                    let encontrada = false
                    for (let e = 0; e < this.camposConfigurar.length; e++) {
                        if(this.camposConfigurar[e].varSeleccionada != null){
                            if(this.camposConfigurar[e].varSeleccionada.idVeriableDefecto == this.variablesOpciones[i].idVeriableDefecto){
                                this.variablesOpciones[i]["$isDisabled"] = true
                                encontrada = true
                                break
                            }
                        }
                    }
                    if(!encontrada)
                        this.variablesOpciones[i]["$isDisabled"] = false
                    /*if(this.variablesOpciones[i].idVeriableDefecto === value.varSeleccionada.idVeriableDefecto){
                        console.log("entro")
                        this.variablesOpciones[i]["$isDisabled"] = true
                        encontrada = true
                        break
                    } */
                    
                }
                /*for (let e = 0; e < this.camposConfigurar.length; e++) {
                    if(this.camposConfigurar[e].varSeleccionada != null){
                        for (let i = 0; i < this.variablesOpciones.length; i++) {
                            if(this.variablesOpciones[i].idVeriableDefecto === this.camposConfigurar[e].varSeleccionada.idVeriableDefecto){
                                this.variablesOpciones[i]["$isDisabled"] = true
                            }

                        }
                    }
                }*/
                /*const objeto2 = this.variablesOpciones[i];
                    const variable = objeto2;

                    // Verificar si el objeto está seleccionado en arreglo1
                    const estaSeleccionado = this.camposConfigurar.some(objeto1 => objeto1.varSeleccionada === variable);

                    // Actualizar $isDisabled en consecuencia
                    objeto2.$isDisabled = !estaSeleccionado;*/

                /*this.variablesOpciones.forEach(varbl => {
                    if(varbl.idVeriableDefecto == value.varSeleccionada.idVeriableDefecto){
                        varbl["$isDisabled"] = true
                    } else{
                        let encontr = false
                        this.camposConfigurar.forEach(campo=>{
                            if(campo.varSeleccionada != null)
                                if(campo.varSeleccionada.idVeriableDefecto == varbl)
                                    encontr = true
                        })
                        if(encontr){
                            varbl["$isDisabled"] = true
                        }
                    }
                })*/

            },
            configurarColumnas: function(campos, variables){
                this.mostrarModalConfigColumnas = true
                this.camposConfigurar = campos
                this.variablesOpciones = variables

            },
            cerrarModalConfigColumnas: function(){
                this.mostrarModalConfigColumnas = false
            },
            configurarVariablesTemplate: function(template){
                console.log(template.variables)
                this.templateModificar = template
                this.camposConfigurar = template.variables
                this.mostrarModalConfigColumnas = true
            },
            subirDocumentoTemplate: function(documento){
                this.documentoTemplateModal = documento
                this.mostrarSubirArchivos = true
                this.generarLinkSubidaArchivos()
                /*console.log(documento)
                console.log(this.$refs)
                this.$refs[documento.idTemplateDocumento.toString()].forEach(archivo =>{
                    console.log(documento.archivosSubir[0].id)
                    console.log(archivo.files[0].id)
                    if(documento.archivosSubir[0].id == archivo.files[0].id){
                        archivo.active = true
                    }
                })
                //this.$refs[documento.idTemplateDocumento].active = true
                //$refs.upload.remove(documento.archivosSubir[0])*/
            },
            getDocumentosTemplate: function(){
                if(this.tipoDocumentoSelected != null && this.empresaSelected != null){
                    this.loadingDocumentosTemplate = true
                    let url =  this.urlBase + "/get_documentos_template/"
                    axios({
                        method: "POST", 
                        "url": url,
                        "data": {
                            "filtrarPorPeriodo": this.mostrarPeriodo,
                            "idEmpresa": this.empresaSelected.idEmpresa,
                            "idTipoDocumento": (this.tipoDocumentoSelected != null) ? this.tipoDocumentoSelected.idTipoDocumento : 'null',
                            "mes": (this.mesSelected != null) ? this.mesSelected.valor : null,
                            "anio": (this.periodoSelected != null) ? this.periodoSelected.valor : null
                        },
                        "headers": {
                            'Authorization': `${this.tokenLogin}`
                        }
                    }).then(result => {
                        this.documentosTemplate = result.data.templateDocs
                        this.mostrarNotificaciones(1, result.data.mensajeGeneral)
                    this.loadingDocumentosTemplate = false
                        
                    }, error => {
                        this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                    this.loadingDocumentosTemplate = false
                    })
                    .finally(() => {
                    });
                }
            },
            /* secciones Header */
            obtenerTiposDocumentos: function(){
                this.isLoadingTipoDocumentos = true

                var url =  this.urlBase + "/get_tipos_documentos/"
                
                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.tipoDocumentos = result.data.tiposDocumentos
                    if(this.$route.query.idDocSelec != null){
                        this.tipoDocumentos.forEach(doc =>{
                            if(this.$route.query.idDocSelec == doc.idTipoDocumento){
                                this.seleccionarTipoDocumento(doc)
                            }
                        })
                    } 
                    else if(this.tipoDocumentos.length == 1){
                        this.tipoDocumentoSelected = this.tipoDocumentos[0]
                    }

                }, error => {
                    this.errorDctos = error.response.data
                })
                .finally(() => {
                    this.isLoadingTipoDocumentos = false
                });
            },            
            seleccionarTipoDocumento: function(tipoDoc){
                this.tipoDocumentoSelected = tipoDoc
                if(this.empresaSelected != null){
                    this.getDocumentosTemplate()
                }
                /*if(tipoDoc.valor =='contratos')
                    this.obtenerEmpresas(tipoDoc)
                else{
                    if(this.periodoSelected != null) 
                        this.seleccionarAnioPeriodo(this.periodoSelected)
                    else{
                        this.empresas = []
                        this.empresasFiltradas = []
                    }
                }*/
            },
            seleccionarAnioPeriodo: function(anio){
                this.periodoSelected = anio
                if(/^true$/i.test(this.$route.query.mostrarPeriodo)){
                    if(this.$route.query.mesPeriodo != null){
                        this.periodoSelected.meses.forEach(mes =>{
                            if(this.$route.query.mesPeriodo == mes.valor){
                                this.seleccionarMeses(mes)
                            }
                        })
                    } 
                }
                if(this.periodoSelected != null && this.mesSelected != null){
                    this.obtenerEmpresas()
                }

            },
            seleccionarMeses: function(mes){
                this.mesSelected = mes
                if(this.periodoSelected != null && this.mesSelected != null){
                    this.obtenerEmpresas()
                }
            },
            obtenerPeriodos: function(){

                this.isLoadingPeriodos = true
                var url = this.urlBase + apiUrls.remuneraciones.getPeriodos

                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.periodos = result.data
                    if(/^true$/i.test(this.$route.query.mostrarPeriodo)){
                        if(this.$route.query.anioPeriodo != null){
                            this.periodos.forEach(per =>{
                                if(this.$route.query.anioPeriodo == per.valor){
                                    this.seleccionarAnioPeriodo(per)
                                }
                            })
                        } 
                    }
                }, error => {
                    this.mensajeNotificacion = "Ups, Tuvimos un problema al obtener los periodos, si el problema persiste contacte con nuestro soporte, Gracias."
                })
                .finally(() => {
                    this.isLoadingPeriodos = false
                });
            },
            obtenerEmpresas: function(){

                if(this.rqstEmps != null){
                    this.rqstEmps.cancel()
                    this.rqstEmps.msg = "cancelado";
                    this.rqstEmps = null;
                    
                    this.isLoadingEmpresas = false
                }
                const axiosSource = axios.CancelToken.source();
                this.rqstEmps = { cancel: axiosSource.cancel, msg: "Cargando..." };
                this.empresas = []
                this.isLoadingEmpresas = true
                
                let url =  this.urlBase + apiUrls.general.getEmpresas
                
                
                axios({
                    method: "POST", 
                    "url": url,
                    cancelToken: axiosSource.token,
                    "data": {
                        "tipoBD": "REMU",
                        "filtrarPorPeriodo": this.mostrarPeriodo,
                        "anioPeriodo": (this.periodoSelected != null) ? this.periodoSelected.valor : null,
                        "mesPeriodo":(this.mesSelected != null) ? this.mesSelected.valor : null,
                        "tipoDocumento": "contratos",
                        "empSelecteds": this.emFlt,
                        "paginacionEmpresas": {
                            "actual": this.paginacionEmpresas.current,
                            "tamanioPagina": this.paginacionEmpresas.pageSize
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.empresas = result.data.empresas

                    if(this.empresas.length<=0)
                        this.locale.emptyText = "No hay empresas para mostrar"

                    if(this.$route.query.idEmpresa != null){
                        this.empresas.forEach(emp =>{
                            if(this.$route.query.idEmpresa == emp.idEmpresa){
                                this.seleccionarEmpresa(emp)
                            }
                        })
                    } 

                    const pagination = { ...this.paginacionEmpresas };
                    pagination.total = result.data.totalEmpresas
                    this.paginacionEmpresas = pagination

                    this.isLoadingEmpresas = false
                    this.rqstEmp = null
                    if(result.data.mensajeGeneral != null){
                        this.mostrarNotificaciones(2, result.data.mensajeGeneral)
                    }
                }, 
                error => {
                    this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                    this.isLoadingEmpresas = false
                    this.rqstEmp = null
                })
                .finally(() => {
                });
                
            },
            seleccionarEmpresa: function(empresa){
                this.empresaSelected = empresa
                if(this.tipoDocumentoSelected != null)
                    this.getDocumentosTemplate(empresa)
            },
            /* Fin secciones Header */

            agregatTipoDoc: function(tag){
                let td = {"idTipoDocumentoSub": 0, "nombreTipoDocumentoSub": tag, "nombreVisibleSub": tag, "idTipoDocumentos": this.tipoDocumentoSelected.idTipoDocumento }
                this.tipoDocumentoSelected.tipoSubDocumentos.push(td)
                this.tipoSubDocumentoSelected = td
                this.generarLinkSubidaArchivos()
            
            },

            subirTodoActivar: function(empresa){
                if(this.subidaDocsID == null){
                    
                    this.$refs.upload.active = true
                    this.validarDocsError(empresa)

                    var idInt = setInterval(function(){
                        this.validarDocumentosSubidos(empresa);
                    }.bind(this), 1000);
                    this.subidaDocsID = idInt
                }

            },
            validarDocsError: function(empresa){
                this.archivosSubir.forEach(archivo => {
                    if(!archivo.success && archivo.error != ""){
                        this.$refs.upload.update(archivo, {active: true,error: '',progress: '0.00'})
                    }
                });

            },
            validarDocumentosSubidos: function(empresa){
                if(this.archivosSubir.length == 0){
                    clearInterval(this.subidaDocsID)
                    this.subidaDocsID = null
                }
                else{
                    var finalizados = 0
                    this.archivosSubir.forEach(archivo => {
                        if((!archivo.active && parseInt(archivo.progress) == 100) || (!archivo.active && archivo.error == "Cancelado") || (!archivo.active && archivo.success) || (!archivo.active && !archivo.success)){
                            finalizados++
                        }
                    })
                    if(finalizados == this.archivosSubir.length){
                        clearInterval(this.subidaDocsID)
                        this.subidaDocsID = null
                        //this.obtenerTrabajadores(true, empresa)
                    }
                }
            },

            generarLinkSubidaArchivos: function(){
                //${urlBase}/subir_documento_template/${empresaSelected.idEmpresa}/${documento.idTemplateDocumento}/${documento.idTipoDocumentoSub}`"
                if(this.documentoTemplateModal == null)
                    if(this.tipoSubDocumentoSelected == null)
                        this.mostrarNotificaciones(2, "Seleccione el tipo de Documento a subir")
                if(this.empresaSelected == null){
                    this.mostrarNotificaciones(2, "Seleccione la empresa")
                }

                let idSub = this.documentoTemplateModal != null ? this.documentoTemplateModal.idTipoDocumentoSub : (this.tipoSubDocumentoSelected != null ? this.tipoSubDocumentoSelected.idTipoDocumentoSub : null)
                let idTemplate = this.documentoTemplateModal != null ? this.documentoTemplateModal.idTemplateDocumento : null
                this.linkSubir = `${this.urlBase}/subir_documento_template/${this.empresaSelected.idEmpresa}/${this.tipoDocumentoSelected.idTipoDocumento}/${idSub}/${idTemplate}`
                
            },
            seleccionarSubTipoDocumento: function(){
                this.generarLinkSubidaArchivos()
            },
            modificarNombreTemplate: function(nombre, archivo){
                let idSub = this.documentoTemplateModal != null ? this.documentoTemplateModal.idTipoDocumentoSub : (this.tipoSubDocumentoSelected != null ? this.tipoSubDocumentoSelected.idTipoDocumentoSub : null)
                let idTemplate = this.documentoTemplateModal != null ? this.documentoTemplateModal.idTemplateDocumento : null
                let nombreTemplate = nombre
                if(nombre == "" || nombre == " "){
                    nombreTemplate = archivo.name.split(".")[0]
                }
                //this.linkSubir = `${this.urlBase}/subir_documento_template/${this.empresaSelected.idEmpresa}/${this.tipoDocumentoSelected.idTipoDocumento}/${idSub}/${idTemplate}/${nombreTemplate}`
                archivo.postAction = `${this.urlBase}/subir_documento_template/${this.empresaSelected.idEmpresa}/${this.tipoDocumentoSelected.idTipoDocumento}/${idSub}/${idTemplate}/${nombreTemplate}`
            },
            inputFile(newFile, oldFile) {
                if(newFile && !oldFile){
                    newFile.nombreTemplate = newFile.name.split(".")[0]
                    this.modificarNombreTemplate(newFile.nombreTemplate, newFile)
                }
                if (newFile && oldFile) {
                    // update
                    if(newFile.name.split(".")[0] != newFile.nombreTemplate){
                        this.modificarNombreTemplate(newFile.nombreTemplate, newFile)
                    }
                    
                    //console.log(newFile, oldFile)
                    //newFile.nombreTemplate = newFile.name.split(".")[0]
                    //this.modificarNombreTemplate(newFile.nombreTemplate, newFile)
                    if (newFile.active && !oldFile.active) {
                    // beforeSend
                    // min size
                    if (
                        newFile.size >= 0 &&
                        this.minSize > 0 &&
                        newFile.size < this.minSize
                    ) {
                        this.$refs.upload.update(newFile, { error: "size" });
                    }
                    }
                    if (newFile.progress !== oldFile.progress) {
                        // progress
                    }
                    if (newFile.error && !oldFile.error) {
                        // error
                        //msjArchivo
                        this.mostrarNotificaciones(2, newFile.response.mensajeGeneral)
                    }
                    if (newFile.success && !oldFile.success) {
                        // success
                        this.getDocumentosTemplate()
                    }
                }
                if (!newFile && oldFile) {
                    // remove
                    if (oldFile.success && oldFile.response.id) {
                        // $.ajax({
                        //   type: 'DELETE',
                        //   url: '/upload/delete?id=' + oldFile.response.id,
                        // })
                    }
                } 
                // Automatically activate upload
                if (
                    Boolean(newFile) !== Boolean(oldFile) ||
                    oldFile.error !== newFile.error
                ) {
                    if (this.uploadAuto && !this.$refs.upload.active) {
                    this.$refs.upload.active = true;
                    }
                }
            },


        }
        
    }
</script>

<style>

.vs-table{
    overflow: hidden !important;
}
.center-content{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;                           
}
.btnEstilo {
    padding: 5px 10px; /* Ajusta el padding para agrandar el botón */
    display: flex; /* Para centrar el contenido si es necesario */
    align-items: center;
    justify-content: center;
}
.modal-body {
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 90vh; /* El modal no puede ser más alto que el 90% de la pantalla */
    overflow-y: auto; /* Permite el scroll dentro del modal */
    padding: 10px;
}

</style>